export default {"src":"/_next/static/media/outcomes-arrow.7cdbb35a.svg","height":177,"width":177,"blurWidth":0,"blurHeight":0};